import { createStyles, makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const useFundInvestmentFormStyles = makeStyles((theme: ITheme) =>
  createStyles({
    section: {
      marginBottom: theme.spacing(3),
    },
  })
);

export default useFundInvestmentFormStyles;
